import React from "react";
import { Modal } from "react-bootstrap";
import closeIcon from "Assets/images/colse-pdf.png";
import CommonButton from "./CommonButton";

const DocViewModal = ({ show, setShow, doc, onAccept, values, showAccept, isAccepting = false }) => {
    const handleClose = () => setShow(false);
    const isAlreadyAccepted = values?.policies?.some(
        (policy) => policy?.policy_id === doc?.id && policy?.is_accepted
    );
    const canAccept = typeof onAccept === "function" && showAccept !== false && !isAlreadyAccepted;

    return (
        <Modal
            className="pdf-viewer-class"
            fullscreen
            show={show}
            onHide={handleClose}
        >
            <Modal.Header className="border-0 p-5 d-flex justify-content-end align-items-center gap-3">
                <div style={{marginRight: "180px"}}>
                    {canAccept && (
                        <CommonButton
                            text="Yes, I Agree"
                            className="button-filled"
                            onClick={onAccept}
                            loading={isAccepting}
                            disabled={isAccepting}
                        />
                    )}
                </div>



                <img
                    src={closeIcon}
                    alt="close"
                    width={20}
                    height={20}
                    style={{ cursor: "pointer" }}
                    onClick={handleClose}
                />
            </Modal.Header>

            {doc && (
                <iframe
                    key={doc?.url}
                    src={`${doc?.url}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                />
            )}


        </Modal>
    );
};

export default DocViewModal;
